<template>
  <div class="hotspot" :style="info.css" @click.prevent="click" data-info="info">
    <!--<div v-show="is_edit" class="name">{{this.info.name}}</div>-->

    <div v-if="loading" class="loading">
      <div class="fall"></div>
      <van-loading type="spinner" color="white"/>
    </div>

  </div>
</template>


<script>

  import click_handler from '../../tools/mgtv/click'
  import to_casher from '../../tools/mgtv/casher'
  import handler_action from '../../tools/mgtv/action'
  import {Loading} from 'vant';
  import Vue from 'vue';

  Vue.use(Loading);

  export default {
    name: 'HotSpot',
    props: ['info'],
    data() {
      return {
        loading: false
      }
    },
    methods: {
      click() {
        if (!this.info.action_type || this.info.action_type === 'none') {
          return;
        }
        if (this.loading) {
          return;
        }
        this.loading = true;
        setTimeout(() => {
          this.loading = false
        }, 333);
        click_handler(this.info.name, () => {
          handler_action(this.info)
        }, {
          need_login: this.info.action_info.need_login,
          need_act: this.info.action_info.need_act,
          need_new_user:this.info.action_info.need_new_user,
          need_vip_level: this.info.action_info.need_vip_level,
        })
      },

    },
    computed: {
      is_edit() {
        return gact.edit
      },

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

  @import "../../share/mixins.styl"

  .hotspot
    position relative

  .name
    font-size .3rem
    color edit_color
    width 100%
    height 100%
    line-height 100%
    vertical-align center
    display flex
    justify-content center
    align-items center
    font-weight bolder

  .loading
    position absolute
    width 100%
    height 100%
    top 0
    left 0
    display flex
    justify-content center
    align-items center

  .fall
    position absolute
    width 100%
    height 100%
    top 0
    left 0
    background-color: rgba(0, 0, 0, .3);


</style>


<style lang="stylus">


</style>



// WEBPACK FOOTER //
// src/components/ConfigUI/HotSpot.vue